import React from 'react'
import close from '../../assets/images/close.svg'

const DeleteMenuPopup = ({ showDeletePopup, setShowDeletePopup, reference, confirmDelete, isLoading}) => {
    return (
        <>
            {showDeletePopup && (
                <>
                    <div className="popup-overlay">
                    </div>
                    <div className="popup-box delete-popup" ref={reference}>
                        <div className="popupTop popupTopClose closePlan previewClose">
                            <img src={close} onClick={() => setShowDeletePopup(false)} alt="Icon" />
                        </div>
                        <div className='popupModalTitle'>
                            Are you sure want to delete menu?
                        </div>
                        <p className='popupDesc'>You can not revert it</p>
                        <div className="popup-actions">
                            <button className="cancel-btn" onClick={() => setShowDeletePopup(false)}>Cancel</button>
                            <button className="save-btn delete-btn" onClick={() => {
                                confirmDelete();
                            }}>
                                {isLoading ?
                                    <div className={`ringLoader loaderContinue`}></div>
                                    :
                                    'Delete'
                                }
                            </button>
                        </div>
                    </div>
                </>
            )}

        </>
    )
}

export default DeleteMenuPopup